import { Outlet, useLocation } from 'react-router-dom'
import Header, { darkHeaderRoutes } from './Header'
import Footer from './Footer'
import WhatsAppButton from './WhatsAppButton'

export default function Layout() {
  const { pathname } = useLocation()
  // Nas páginas de hero escuro o header flutua sobre o hero, então o conteúdo
  // começa no topo da página (sem faixa reservada para o header)
  const heroUnderHeader = darkHeaderRoutes.includes(pathname)

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className={`flex-1 ${heroUnderHeader ? '' : 'pt-20'}`}>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  )
}
